module.exports = __webpack_public_path__ + "media/images/bg05-f31eb797bb0b722a791bf7d759da6fa2.png";